import React from 'react';
import { Position } from 'reactflow';
import 'reactflow/dist/style.css';
import HandleComponent from './HandleComponent';

const NodeHandles = ({
  nodeId,
  inputs,
  outputs,
  isConnectable,
  isTemp,
  packageType,
  vertical = false,
}) => {
  const inputProps = inputs?.properties || {};
  const outputProps = outputs?.properties || {};
  const connectable = Boolean(isConnectable) && !isTemp;
  const targetPos = vertical ? Position.Top : Position.Left;
  const sourcePos = vertical ? Position.Bottom : Position.Right;

  const renderHandles = (properties, type, position) =>
    Object.entries(properties).map(([id, schema], index, array) => (
      <HandleComponent
        key={`${type}-${id}`}
        nodeId={nodeId}
        type={type}
        position={position}
        id={id}
        schema={schema}
        index={index}
        total={array.length}
        isConnectable={connectable}
        packageType={packageType}
      />
    ));

  return (
    <>
      {renderHandles(inputProps, 'target', targetPos)}
      {renderHandles(outputProps, 'source', sourcePos)}
    </>
  );
};

export default NodeHandles;
